import React, { FC, InputHTMLAttributes } from 'react';
import { Radio, HiddenRadio, Label, Wrapper } from './styles';

export interface FormCheckProps {
    label?: string;
}

const FormRadio: FC<InputHTMLAttributes<HTMLInputElement> & FormCheckProps> = ({ label, checked, ...props }) => {
    return (
        <Wrapper>
            <HiddenRadio type="radio" checked={checked} {...props} />
            <Radio checked={checked} />
            {label && <Label>{label}</Label>}
        </Wrapper>
    );
};

export default FormRadio;
